"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _constants = require("../constants.js");

var _utils = require("../utils.js");

var _RangeControlOverlay = _interopRequireDefault(require("./RangeControlOverlay.js"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

/**
 * Slider
 *
 * A wrapper around <RangeControlOverlay /> that may be used to
 * compose slider controls such as volume sliders or progress bars.
 */
var Slider = (_class =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  function Slider() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Slider)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.$el = null, _temp));
  }

  _createClass(Slider, [{
    key: "storeRef",
    value: function storeRef($el) {
      this.$el = $el;
    }
  }, {
    key: "handleIntent",
    value: function handleIntent(intent) {
      if (this.props.isEnabled) {
        this.props.onIntent(intent);
      }
    }
  }, {
    key: "handleIntentStart",
    value: function handleIntentStart(intent) {
      if (this.props.isEnabled) {
        this.props.onIntentStart(intent);
      }
    }
  }, {
    key: "handleIntentEnd",
    value: function handleIntentEnd() {
      if (this.props.isEnabled) {
        this.props.onIntentEnd();
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      if (this.props.isEnabled) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "handleChangeStart",
    value: function handleChangeStart(value) {
      if (this.props.isEnabled) {
        this.props.onChangeStart(value);
      }
    }
  }, {
    key: "handleChangeEnd",
    value: function handleChangeEnd(value) {
      if (this.props.isEnabled) {
        this.props.onChangeEnd(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          direction = _this$props.direction,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          overlayZIndex = _this$props.overlayZIndex;
      return _react.default.createElement("div", {
        ref: this.storeRef,
        className: className,
        style: _objectSpread({
          position: 'relative'
        }, style)
      }, children, _react.default.createElement(_RangeControlOverlay.default, {
        direction: direction,
        bounds: function bounds() {
          return _this2.$el.getBoundingClientRect();
        },
        onIntent: this.handleIntent,
        onIntentStart: this.handleIntentStart,
        onIntentEnd: this.handleIntentEnd,
        onChange: this.handleChange,
        onChangeStart: this.handleChangeStart,
        onChangeEnd: this.handleChangeEnd,
        style: {
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: overlayZIndex
        }
      }));
    }
  }]);

  return Slider;
}(_react.PureComponent), (_applyDecoratedDescriptor(_class.prototype, "storeRef", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "storeRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntent", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentStart", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleIntentEnd", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleIntentEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChangeStart", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChangeStart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChangeEnd", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class.prototype, "handleChangeEnd"), _class.prototype)), _class);
Slider.propTypes = {
  direction: _propTypes.default.oneOf([_constants.Direction.HORIZONTAL, _constants.Direction.VERTICAL]),
  isEnabled: _propTypes.default.bool,
  onIntent: _propTypes.default.func,
  onIntentStart: _propTypes.default.func,
  onIntentEnd: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeStart: _propTypes.default.func,
  onChangeEnd: _propTypes.default.func,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  overlayZIndex: _propTypes.default.number
};
Slider.defaultProps = {
  direction: _constants.Direction.HORIZONTAL,
  isEnabled: true,
  onIntent: _utils.noop,
  onIntentStart: _utils.noop,
  onIntentEnd: _utils.noop,
  onChange: _utils.noop,
  onChangeStart: _utils.noop,
  onChangeEnd: _utils.noop,
  children: null,
  className: null,
  style: {},
  overlayZIndex: 10
};
var _default = Slider;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-player-controls/dist/components/Slider.js
// module id = 1028
// module chunks = 168707334958949